import store from "../vuex/store";
class WebSocketClient {
    constructor() {
        this.websocket = null;
        this.connected = false;
        this.heartbeatInterval = null;
        this.reconnectInterval = null;
        this.messageReceivedCallback = null;
        this.heartbeatStartedCallback = null;
        this.IP = ''
    }

    connect (IP) {
        const wsUri = `ws://${IP}/api/ws/info`;
        this.IP = IP;
        let token = store.state.logintoken || '';
        if(!token){
            return;
        }
        this.websocket = new WebSocket(wsUri, [token.split(' ')[1]]);

        this.websocket.onopen = () => {
            this.connected = true;
            this.startHeartbeat();
        };

        this.websocket.onmessage = (event) => {
            const message = JSON.parse(event.data);
            if (message.type === "pong") {
                this.onPongReceived();
            } else {
                this.onMessageReceived(message);
            }
        };

        this.websocket.onclose = () => {
            this.connected = false;
            this.stopHeartbeat();
            this.reconnectWebSocket();
        };

        this.websocket.onerror = (error) => {
            console.error("WebSocket error: ", error);
        };
    }

    sendMessage (message) {
        if (this.connected) {
            this.websocket.send(JSON.stringify(message));
        } else {
            console.error("WebSocket is not connected.");
        }
    }
    setHeartbeatStartedCallback(callback) {
        this.heartbeatStartedCallback = callback;
    }
    startHeartbeat () {
        if (this.heartbeatStartedCallback) {
            this.heartbeatStartedCallback();
        }
        this.heartbeatInterval = setInterval(() => {
            this.sendMessage({ type: "ping" });
        }, 30e3);
    }

    stopHeartbeat () {
        clearInterval(this.heartbeatInterval);
    }

    reconnectWebSocket () {
        this.reconnectInterval = setTimeout(() => {
            this.connect(this.IP);
        }, 5000);
    }

    closeWebSocket () {
        if (this.connected) {
            this.websocket.close();
        }
    }

    onPongReceived () {
        // Customize behavior when pong received
    }
    setMessageReceivedCallback(callback) {
        this.messageReceivedCallback = callback;
    }

    onMessageReceived (message) {
        if (this.messageReceivedCallback) {
            this.messageReceivedCallback(message);
        }
    }
}

export default WebSocketClient;


// WEBPACK FOOTER //
// ./src/utils/WebSocket.js